import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { StartSupportFlowRequest } from '@cash-web/shared-util-protos/squareup/franklin/support.pb'
import { StartSupportFlowResponse } from '@cash-web/shared-util-protos/squareup/franklin/support.pb'

export const startSupportFlow = (request: StartSupportFlowRequest, options?: CashRequestOptions) =>
  post<StartSupportFlowRequest, StartSupportFlowResponse>('/2.0/cash/start-support-flow', request, {
    ...options,
    rejectOnError: true,
  })
